jQuery(document).ready(function ($) {

    $('button.hamburger').click(function () {
        const header = $('.flex-header'),
            headerMenu = $('.flex-header__menu');

        $('button.hamburger').toggleClass('is-active');
        header.toggleClass('menu-open');
        headerMenu.stop().slideToggle(250);
    });

    /* when to transform */

    transformFixedElement("header");

    window.addEventListener('scroll', function () {
        transformFixedElement("header");
    });

    $(document).on('click', '.menu-item-has-children > a > svg', function (e) {
        const $this = $(this),
            parent = $this.closest('.menu-item-has-children');

        if (parent.eq(0).hasClass('menu--expanded')) {
            parent.eq(0).removeClass('menu--expanded').find('.sub-menu').eq(0).stop().slideUp(250);
        } else {
            parent.siblings('.menu-item-has-children').removeClass('menu--expanded').find('.sub-menu').stop().slideUp(250);
            parent.eq(0).addClass('menu--expanded').find('.sub-menu').eq(0).stop().slideDown(250);
        }

        return false;
    });

});

function transformFixedElement(element) {
    var distanceY = window.pageYOffset || document.documentElement.scrollTop,
        transformOn = 150,
        header = $(element),
        configuratorBtn = $('.configurator-button');
    if (distanceY > transformOn) {
        header.addClass("is-active").removeClass("search-active");
        configuratorBtn.removeClass('is-active');
    } else {
        if (header.hasClass("is-active")) {
            header.removeClass("is-active");
        }
        configuratorBtn.addClass('is-active');
    }
}

